"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleTypeConfigs = {
    /**
     * Default Layout
     */
    default: {
        responsive: [{ breakpoint: 480, settings: { arrows: true } }],
    },
    /**
     * Feature / Header Layout with autoplay
     */
    type1: {
        arrowsOnHover: true,
        autoplay: true,
        dots: true,
        dotsDistance: 14,
        infinite: true,
        scrollStepwise: true,
        slideGap: 0,
        sliderPaddingBottom: 28,
        slidesToScroll: 1,
        slidesToShow: 1,
        responsive: [{ breakpoint: 480, settings: { arrows: true } }],
    },
    /**
     * Card-Layout
     */
    type2: {
        arrowsDistance: -20,
        background: '#f4f4f4',
        framePadding: 12,
        hasCardLayout: true,
        itemOverflow: true,
        slideGap: 12,
        sliderPaddingBottom: 6,
        responsive: [
            { breakpoint: 480, settings: { arrows: true, framePadding: 24, itemOverflow: false } },
        ],
    },
};
var getStyleTypeConfig = function (styleType) { return styleTypeConfigs[styleType]; };
exports.default = getStyleTypeConfig;
//# sourceMappingURL=getSliderConfig.js.map